import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=4ec02502"
import script from "./modal.vue?vue&type=script&lang=ts"
export * from "./modal.vue?vue&type=script&lang=ts"
import style0 from "./modal.vue?vue&type=style&index=0&id=4ec02502&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports